import React from 'react';

const ClampedParagraph = ({ text }) => {
  const [clamped, setClamped] = React.useState(true);
  const [showButton, setShowButton] = React.useState(true);
  const containerRef = React.useRef(null);
  const handleClick = () => setClamped(!clamped);

  React.useEffect(() => {
    const hasClamping = (el) => {
      const { clientHeight, scrollHeight } = el;
      return clientHeight !== scrollHeight;
    };

    const checkButtonAvailability = () => {
      if (containerRef.current) {
        // Save current state to reapply later if necessary.
        const hadClampClass = containerRef.current.classList.contains("clamped-paragraph");
        // Make sure that CSS clamping is applied if applicable.
        if (!hadClampClass) containerRef.current.classList.add("clamped-paragraph", "overflow-hidden", "line-clamp-2", "text-ellipsis", "break-words");
        // Check for clamping and show or hide button accordingly.
        setShowButton(hasClamping(containerRef.current));
        // Sync clamping with local state.
        if (!hadClampClass) containerRef.current.classList.remove("clamped-paragraph", "overflow-hidden", "line-clamp-2", "text-ellipsis", "break-words");
      }
    };

    const debouncedCheck = (function() {
      let timeout;
      return function() {
        clearTimeout(timeout);
        timeout = setTimeout(checkButtonAvailability, 50);
      };
    })();

    checkButtonAvailability();
    window.addEventListener("resize", debouncedCheck);

    return () => {
      window.removeEventListener("resize", debouncedCheck);
    };
  }, [containerRef]);

  return (
    <>
      <div
        ref={containerRef}
        className={(clamped && "clamped-paragraph overflow-hidden line-clamp-2 text-ellipsis break-words") || ""}
      >
        {text}
      </div>
      {showButton && (
        <a className="text-seqblue hover:text-seqorange cursor-pointer" onClick={handleClick}>{clamped ? "Read more" : "Collapse"}</a>
      )}
    </>
  );
};

export default ClampedParagraph;
